import { BrowserRouter, Route, Switch } from "react-router-dom"
import './App.css';
import About from "./components/About";
import CreateVideogame from "./components/CreateVideogame";
import Home from "./components/Home";
import LandingPage from "./components/LandingPage";
import Navbar from "./components/Navbar";
import VideogameDetail from "./components/VideogameDetail";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/">
          <LandingPage/>
        </Route>
        <Route path="/home">
          <Navbar/>
          <Home/>
        </Route>
        <Route path="/create">
          <Navbar/>
          <CreateVideogame/>
        </Route>
        <Route path="/about">
          <Navbar/>
          <About/>
        </Route>
        <Route path="/:id">
          <VideogameDetail/>
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
